import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

interface BulletProps {
  item: { color: string };
  loading?: boolean;
}

interface DividerProps {
  loading?: boolean;
}

export const LegendContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const Bullet = styled("span", {
  shouldForwardProp: (prop): prop is Exclude<keyof BulletProps, "item" | "loading"> =>
    prop !== "item" && prop !== "loading",
})<BulletProps>(({ theme, item, loading }) => ({
  height: "8px",
  width: "8px",
  backgroundColor: loading ? theme.palette.gray30.main : item.color,
  borderRadius: "50%",
  marginRight: "5px",
  marginTop: "10px",
}));

export const TextContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const ValueTypography = styled(Typography)(() => ({
  color: "#5E6366",
  fontSize: "24px",
  lineHeight: "30px",
}));

export const LabelTypography = styled(Typography)(() => ({
  color: "#919699",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.44px",
  "&:first-letter": {
    textTransform: "capitalize",
  },
}));

export const DividerContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: 21,
  paddingLeft: "33%",
  paddingRight: "33%",
}));

export const Divider = styled("div", {
  shouldForwardProp: (prop): prop is Exclude<keyof DividerProps, "loading"> =>
    prop !== "loading",
})<DividerProps>(({ theme, loading }) => ({
  height: 1,
  backgroundColor: loading ? theme.palette.gray30.main : "#C6CACC",
  display: "none",
}));
